import * as React from "react";
import { AccuracySupplementalTypeEnum, NPIStatus } from "@app/projects/enumerators";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { JSX } from "react";

export const getSupplementalDataDecoration = (supplementValue: string | React.ReactNode, supplementalType: AccuracySupplementalTypeEnum, sourceData: string): JSX.Element => {
  switch (supplementalType) {
    case AccuracySupplementalTypeEnum.Valid:
      return (
        <div className="text-success">
          <QesIcon iconName={QesIcons.Check} description="This information is valid" className="mx-2 align-text-top" />
          {typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}
        </div>
      );
    case AccuracySupplementalTypeEnum.Invalid:
      return (
        <div className="text-danger">
          <QesIcon iconName={QesIcons.X} description="This information is invalid" className="mx-2 align-text-top" />
          <s>{typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}</s>
        </div>
      );
    case (AccuracySupplementalTypeEnum.Enriched):
      return (
        <div>
          {sourceData &&
            <div className="text-danger">
              <QesIcon iconName={QesIcons.X} description="This information is invalid" className="mx-2 align-text-top" />
              <s>{sourceData}</s>
            </div>
          }
          <div className="text-info">
            <QesIcon iconName={QesIcons.StarV1} description="This information is enriched" className="mx-2 align-text-top" />
            {typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}
          </div>
        </div>
      );

    default:
      return (
        <div className="text-muted">
          <QesIcon iconName={QesIcons.Help} description="The accuracy of this information is unknown" className="mx-2 align-text-top" />
        </div>
      );
  }
};

export const getSupplementalDataDecorationWithoutSource = (supplementValue: string | React.ReactNode, supplementalType: AccuracySupplementalTypeEnum): JSX.Element => {
  switch (supplementalType) {
    case AccuracySupplementalTypeEnum.Valid:
      return (
        <div className="text-success">
          <QesIcon iconName={QesIcons.Check} description="This information is valid" className="mx-2 align-text-top" />
          {typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}
        </div>
      );
    case AccuracySupplementalTypeEnum.Invalid:
      return (
        <div className="text-danger">
          <QesIcon iconName={QesIcons.X} description="This information is invalid" className="mx-2 align-text-top" />
          <s>{typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}</s>
        </div>
      );
    case (AccuracySupplementalTypeEnum.Enriched):
      return (
        <div>
          <div className="text-info">
            <QesIcon iconName={QesIcons.StarV1} description="This information is enriched" className="mx-2 align-text-top" />
            {typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}
          </div>
        </div>
      );

    default:
      return (
        <div className="text-muted">
          <QesIcon iconName={QesIcons.Help} description="The accuracy of this information is unknown" className="mx-2 align-text-top" />
        </div>
      );
  }
};

export const valueOrDashes = (value: string | NPIStatus | boolean | number, numberAsCurrency?: boolean): React.ReactNode => {
  let result: React.ReactNode = value;

  if (typeof result === "boolean") {
    result = result === undefined
      ? null
      : value
        ? "Y"
        : "N";
  }
  if (numberAsCurrency && (typeof result === "number")) {
    result = result
      ? `$${result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
      : result;
  }

  return result || "---";
};

export const bandDisplayNames = (bandGroup: string): string => {
  switch (bandGroup) {
    case "Accurate":
      return "Valid";
    case "Inaccurate":
      return "Invalid";
    case "Enriched":
    case "Skipped":
    case "Suspect":
    default:
      return bandGroup;
  }
}